module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAmCAYAAACCjRgBAAABAElEQVRYhe2YQQ7EIAhFYTL3vzKzaRNqmKr4kZjwki5qo/ILKEpUFMXRsKeTiPQHZhYRcY3PPN7t45lgwIC+QhBwAdefRw/7F6iA3cYTEX1RA1nG90LJmyMaiADL+J4nZhL1jeUQyggbzbIAEWHU3/QACaFLxMMTu0TBktgSgUjSHtBlNCOc4BvZbhEhpcSO0LkJEUC0T0SYgF2UgGxKQDbHC/AudY/yc2XJtM7OMxuhuxbSk64c4Fc5PoRg1ahGHyVbT1nt+vusJ90C3oyxwqs1rvc+SkgOjNwLoXIo6l6I72ekz+0hz3xpSdwa7BURsg9YxrXtus0Iv7xbgqI4jB/b+6g3ouzViQAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/walleris/images/IEBACK.png
// module id = 64
// module chunks = 0